import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-14 md:py-16">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <span className="text-white font-bold text-lg font-heading">J</span>
              </div>
              <span className="font-heading font-bold text-xl text-white">JMTT</span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed">
              JMTT是您值得信赖的优质平台，提供全面的服务与解决方案，助力每一位用户实现数字化升级与业务增长。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/categories" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">分类浏览</Link></li>
              <li><Link to="/about" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">服务支持</h4>
            <ul className="space-y-2.5">
              <li><Link to="/categories?cat=tutorial" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">使用教程</Link></li>
              <li><Link to="/about" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">联系客服</Link></li>
              <li><Link to="/categories?cat=platform" className="text-foreground-300 hover:text-white text-sm transition-colors cursor-pointer">平台公告</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-foreground-300 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-0000</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@jmtt.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span>北京市朝阳区建国路88号JMTT大厦</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400 text-xs">
            &copy; 2026 JMTT. 保留所有权利。
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 hover:text-white text-xs transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-400 hover:text-white text-xs transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-foreground-400 hover:text-white text-xs transition-colors" rel="nofollow">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}